import React from 'react';
import { ProductImage } from 'anf-core-react';
import tmntHelpers from '../../../../tools/tmntHelpers';

const ThumbnailItem = ({
  image,
  index,
  isSelected,
  onClick,
  onKeyDown,
  onImageError,
  onImageLoad,
  tmntData,
  totalImages,
}) => (
  <li
    role="tab"
    className="thumbnail-slider-container__image-wrapper"
    data-highlight={isSelected}
    tabIndex={isSelected ? 0 : -1}
    aria-selected={isSelected}
    aria-posinset={index + 1}
    aria-setsize={totalImages}
    aria-label={tmntHelpers.replacePlaceholders(
      tmntData?.altImagesThumbItemLabel?.value,
      {
        currentImageIndex: index + 1,
        productImageType: image?.type,
        imagesListLength: totalImages,
      },
    )}
    onKeyDown={onKeyDown}
    onClick={() => onClick(index)}
    id={`pdp-thumbnail-${index}`}
    data-testid={`thumbnail-${index}`}
  >
    <div className="thumbnail-slider-container__loading-placeholder" />
    <ProductImage
      src={image?.thumbnailSrc}
      alt={tmntHelpers.replacePlaceholders(
        tmntData?.productImageListAlt?.value,
        {
          imageIndex: index + 1,
          productImageType: image?.type,
        },
      )}
      onError={() => onImageError?.(image?.imageId)}
      onLoad={() => onImageLoad?.(image?.imageId)}
      classList="thumbnail-slider-container__image"
      tabIndex="-1"
    />
  </li>
);

export default ThumbnailItem;
